import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

export interface MessagePopupSimpleData {
  title: string;
  content: string[];
}

@Component({
  selector: 'app-messagepopup-simple',
  standalone: true,
  imports: [CommonModule, MatDialogModule],
  templateUrl: './messagepopup-simple.component.html',
  styleUrls: ['./messagepopup-simple.component.scss']
})
export class MessagepopupSimpleComponent {
  title: string;
  content: string[];

  constructor(
    public dialogRef: MatDialogRef<MessagepopupSimpleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MessagePopupSimpleData
  ) {
    this.title = data?.title || '';
    this.content = data?.content || [];
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
